import { render, staticRenderFns } from "./ComposicaoDaReceitaDeVendaDeAnimaisPercentual.vue?vue&type=template&id=4efb288b&scoped=true&"
import script from "./ComposicaoDaReceitaDeVendaDeAnimaisPercentual.vue?vue&type=script&lang=js&"
export * from "./ComposicaoDaReceitaDeVendaDeAnimaisPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb288b",
  null
  
)

export default component.exports